import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type CbrSortDirection = "asc" | "desc";

/**
 * Redux state interface for CBR Action Report.
 *
 * @interface CbrARState
 * @property {CbrSortDirection} sortDirection - Current sort direction for the CBR report list
 * @property {string[]} availableKpis - List of available KPIs for the report
 * @property {string[]} affAbosToExpand - List of AFF-ABO identifiers to expand in tree view
 */
interface CbrARState {
  sortDirection: CbrSortDirection;
  availableKpis: string[];
  affAbosToExpand: string[];
}

export const initialState: CbrARState = {
  sortDirection: "asc",
  availableKpis: [],
  affAbosToExpand: [],
};

const { actions, reducer } = createSlice({
  name: "cbrActionReport",
  initialState,
  reducers: {
    toggleSortDirection: (state) => {
      state.sortDirection = state.sortDirection === "asc" ? "desc" : "asc";
    },
    setAvailableKpis: (state, action: PayloadAction<string[]>) => {
      state.availableKpis = action.payload;
    },
    setAffAbosToExpand: (state, action: PayloadAction<string[]>) => {
      state.affAbosToExpand = action.payload;
    },
  },
});

export const { toggleSortDirection, setAvailableKpis, setAffAbosToExpand } = actions;

export default reducer;
